export default {
    search_path: "/search/s.jsp",
    pop_path: "/search/p.jsp",
    recommend_path: "/search/r.jsp",
    autocomplete_path: "/search/a.jsp",
    main_host: "",
    link1: "https://ir.ymlib.yonsei.ac.kr/simple-search?query=", 
    link2: "https://yhrn.yonsei.ac.kr/Search/Result.aspx?search_field=ALL&targetFd=ALL&search_word=" 
}